import { Flex, Icon, IconComponentName, Label } from "@braze/beacon-core"
import { RoundedCard } from "./RoundedCard"
import styled from "styled-components"
import { getColor, useColor } from "@braze/beacon-styling"
import { Dispatch, MouseEventHandler, SetStateAction } from "react"



export const StatusFilter = ({children} : {children : React.ReactNode}) => {

    return (
        <StatusBox>
            {children}
        </StatusBox>
    )
}

export const FilterIcons = ({title, icon, active, color, id, setActive} : {title : string, icon : IconComponentName, active : boolean, color : string|undefined, id : string, setActive : Function}) => {

    return (
        <IconBox active={active} color={color} onClick={() => setActive()}>
            <Icon name={icon} size="sm"/>
            <Label className="label">{title}</Label>
        </IconBox>
    )

}

const StatusBox = styled(Flex)`
    // background: #fff;
    // border-radius: 1.5em;
    // box-shadow: 0px 12px 24px rgba(69, 84, 94, 0.1);
    // border: 1px solid rgba(0, 0, 0, 0.05);
    // padding: 0.5rem 0.5rem;
    height: 70%;
    flex-direction: row;
    margin: 0;
    > * {
        &:not(:last-of-type) {
        margin-right: 1rem;
        }
    }
`

const IconBox = styled(Flex)<{ active : boolean, color : string|undefined}>`
    justify-content: center;
    align-items: center;

    padding: 0.5rem 0.5rem;
    border-radius: 2em;
    border: 1px solid rgba(0, 0, 0, 0.05);

    border: 1px solid ${({active, color}) => active ? color : `rgba(0, 0, 0, 0.05)`};
    background: ${({active, color}) => active ? color : `#fff`};
    opacity: ${active => active ? 0.8 : 1};
    color: ${({active, color}) => active ? `white` : `#A8B3B8`};
    
    
    .label {
        color: ${({active, color}) => active ? `white` : `#A8B3B8`};
        margin-bottom: 0;
        font-size: 14px;
        margin-left: 8px;
        padding: 0;
    }
    `